import { Box } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

export const CreatePracticesStyles = muiStyled(Box)(({ color, theme }) => ({
    height: "100%",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    '.select-learning-unit-placeholder': {
        fontSize: 30,
        marginTop: 20,
        marginLeft: 10
    },
    '.selected-test-taker-summary': {
        display: "flex",
        columnGap: 10,
        alignItems: "center",
        height: 40
    }
}))
